import billingModule from '../../billing.module';

class BillingActionService {
    constructor(
        $q,
        billingActionApiService,
        modalService,
        configProvider,
        payableApiService,
        asNotifier,
        textResources,
        asLoadingMask
    ) {
        this.getGlobalActionsCacheKey = 'getGlobalActions';
        this.$q = $q;
        this.billingActionApiService = billingActionApiService;
        this.modalService = modalService;
        this.configProvider = configProvider;
        this.payableApiService = payableApiService;
        this.asNotifier = asNotifier;
        this.textResources = textResources;
        this.asLoadingMask = asLoadingMask;
        this.promiseCache = {};
    }

    getGlobalActions() {
        if (this.promiseCache[this.getGlobalActionsCacheKey]) {
            return this.promiseCache[this.getGlobalActionsCacheKey].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[this.getGlobalActionsCacheKey] = deferred;

        this.billingActionApiService
            .getGlobalActions()
            .then(data => {
                deferred.resolve(data.actions);
            }, deferred.reject)
            .finally(
                () => delete this.promiseCache[this.getGlobalActionsCacheKey]
            );

        return deferred.promise;
    }

    clearGetGlobalActionsCache() {
        delete this.promiseCache[this.getGlobalActionsCacheKey];
    }

    hasAction(actionName) {
        if (!actionName) {
            return this.$q.resolve(false);
        }

        return this.getGlobalActions().then(
            actions =>
                actions.filter(a => a.action == actionName)[0] != undefined,
            data => data
        );
    }

    openModalAddPayment(resolve, callback) {
        this.modalService
            .openCustom({
                component: 'billingModalAddPayment',
                size: 'md',
                resolve
            })
            .then(
                result => {
                    if (callback) {
                        callback(true, { ...result, ...resolve });
                    }
                },
                result => {
                    if (callback) {
                        callback(false, { ...result, ...resolve });
                    }
                }
            );
    }

    openModalPayment(resolve, callback) {
        this.modalService
            .openCustom({
                component: 'billingModalPaymentForm',
                size: 'md',
                resolve
            })
            .then(
                result => {
                    if (callback) {
                        callback(true, { ...result, ...resolve });
                    }
                },
                result => {
                    if (callback) {
                        callback(false, { ...result, ...resolve });
                    }
                }
            );
    }

    openModalProducts(resolve) {
        this.modalService.openCustom({
            component: 'billingModalProducts',
            size: 'lg',
            resolve
        });
    }

    openModalSelectPlan(resolve, callback) {
        this.modalService
            .openCustom({
                component: 'billingModalSelectPlan',
                size: 'md',
                resolve
            })
            .then(
                result => {
                    if (callback) {
                        callback(true, { ...result, ...resolve });
                    }
                },
                result => {
                    if (callback) {
                        callback(false, { ...result, ...resolve });
                    }
                }
            );
    }

    openModalResendActivationEmail(identifier, resolve, callback) {
        this.modalService
            .openCustom({
                component: 'billingModalResendActivationEmail',
                size: 'md',
                resolve: {
                    email: function() {
                        return identifier;
                    }
                }
            })
            .then(
                result => {
                    if (callback) {
                        callback(true, { ...result, ...resolve });
                    }
                },
                result => {
                    if (callback) {
                        callback(false, { ...result, ...resolve });
                    }
                }
            );
    }

    openModalMakePayment(resolve, callback) {
        const customerAgreementResultIndex = 0;
        const invoiceResultIndex = 1;
        const billingActionResultIndex = 2;

        this.asLoadingMask.show();

        this.$q
            .all([
                this.configProvider.getConfigurations(),
                this.payableApiService.getPayables(),
                this.hasAction('auto-pay:enable')
            ])
            .then(
                data => {
                    resolve.customerAgreementResult =
                        data[customerAgreementResultIndex];
                    resolve.invoiceResult = data[invoiceResultIndex];
                    resolve.billingActionResult =
                        data[billingActionResultIndex];

                    this.addCallback(
                        this.modalService.openCustom({
                            component: 'billingModalMakePayment',
                            size: 'md',
                            resolve: resolve
                        }),
                        resolve,
                        callback
                    );
                },
                () =>
                    this.asNotifier.error(
                        this.textResources.configurationNotLoaded
                    )
            )
            .finally(() => this.asLoadingMask.hide());
    }

    openModalEnrollAutoPay() {
        return this.modalService.openCustom({
            component: 'billingModalEnrollAutoPay',
            size: 'md'
        });
    }

    addCallback(promise, resolve, callback) {
        return promise.then(
            result => {
                if (callback) {
                    callback(true, { ...result, ...resolve });
                }
            },
            result => {
                if (callback) {
                    callback(false, { ...result, ...resolve });
                }
            }
        );
    }
}

export default billingModule.service(
    'billingActionService',
    BillingActionService
);



// WEBPACK FOOTER //
// ./modules/billing/services/action/billingAction.service.js